<template>
    <div v-if="!mobile">
        <div>
            <div class="lkt-manual env_VN">
                <div><img src="/static\images\ja\newManual\achievementStudentManual-1.png" alt="" /></div>
                <div>
                    <p>① コース概要画面にある「進捗確認」ボタンを押し、進捗確認画面に移動します。</p>
                    <p>&nbsp;※  管理者権限の場合のみ「進捗確認」ボタンが表示されます。</p>
                </div>
                <div><img src="/static\images\ja\newManual\achievementStudentManual-2.png" alt="" /></div>
                <div>
                    <p>② 検索キーワードを入力し、「検索」ボタンを押して検索結果を確認します。</p>
                    <p>③ 「ファイルのエクスポート」ボタンを押下し、検索結果がEXCELファイルとしてエクスポートされます。</p>
                </div>
            </div>
        </div>
    </div>
    <div v-else>
        <div>
            <div class="lkt-manual env_VN">
                <h1>Mobile</h1>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {};
        },
        components: {},
        computed: {
            mobile() {
                return this.$store.getters["header/mobile"];
            },
        },
        async created() {},
        watch: {},
        methods: {},
    };
</script>
<style scoped>
    .lkt-manual div {
        margin-bottom: 10px;
    }
    .lkt-manual p {
        line-height: 25px;
    }
    img {
        width: 100%;
    }
    p {
        font-size: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/components/manual/content/ja/achievementStudent_manual.vue